// API Configuration with environment variables
export const API_CONFIG = {
  JUDGE0: {
    BASE_URL: process.env.REACT_APP_JUDGE0_BASE_URL ,
    RESULT_URL: (token) => `${process.env.REACT_APP_JUDGE0_RESULT_URL }/${token}?base64_encoded=true`,
    HOST: process.env.REACT_APP_JUDGE0_HOST ,
    KEY: process.env.REACT_APP_JUDGE0_API_KEY 
  },
  GEMINI: {
    API_KEY: process.env.REACT_APP_GEMINI_API_KEY 
  }
};

// Language mappings
export const LANGUAGE_CONFIG = {
  javascript: { id: 63, name: "JavaScript" },
  cpp: { id: 54, name: "C++" },
  java: { id: 62, name: "Java" },
  c: { id: 49, name: "C" },
  python: { id: 71, name: "Python" }
};

// Default code templates
export const CODE_TEMPLATES = {
  javascript: `var message = 'Monaco Editor!'\nconsole.log(message);`,
  cpp: `#include <bits/stdc++.h>\nusing namespace std;\nint main() {\n    cout << "Hello, World!" << endl;\n    return 0;\n}`,
  java: `public class Main {\n    public static void main(String[] args) {\n        System.out.println("Hello, World!");\n    }\n}`,
  c: `#include <stdio.h>\nint main() {\n    printf("Hello, World!\\n");\n    return 0;\n}`,
  python: `print("Hello, World!")`
};
